import { Box, Container, Skeleton, Stack } from '@mui/material'
import { ReactElement, useCallback, useContext } from 'react'
import { useParams } from 'react-router-dom'

import { CustomerPortalAppBar } from '../../components/SharedUICustomerPortal/CustomerPortalAppBar'
import useAuthorizations from '../../hooks/useAuthorizations/useAuthorizations'
import { RepairOrderPortalContext } from '../../providers/RepairOrderPortalProvider/RepairOrderPortalProvider'
import { useUpdateServiceViaApiKeyMutation } from '../../redux/api/inspectionApi'
import { ServiceEntry } from '../../sdk'
import InspectionCustomerUI from './InspectionCustomerUI'

const CustomerPortal: () => ReactElement = () => {
  document.title = 'InTune Auto - Inspection Results'
  const {
    repairOrder,
    services,
    vehicle,
    shop,
    portalInfo,
    authorizations,
    customer
  } = useContext(RepairOrderPortalContext)

  const { apiKey } = useParams()

  const { previousTotal } = useAuthorizations(authorizations)

  const [updateServiceViaApiKey] = useUpdateServiceViaApiKeyMutation()

  const handleDeferOrRecommendService = useCallback(
    async (service: ServiceEntry, isDeferral: boolean) => {
      if (!apiKey) {
        return
      }
      await updateServiceViaApiKey({
        xAPIKey: apiKey,
        customerServiceStatusRequest: {
          serviceId: service.id!,
          isDeferral
        }
      })
    },
    [apiKey, updateServiceViaApiKey]
  )

  return (
    <Box>
      {shop && <CustomerPortalAppBar shop={shop} />}
      <Container maxWidth="lg" sx={{ paddingX: 0 }}>
        <Box justifyContent={'center'} p={2}>
          {repairOrder && vehicle && shop && services ? (
            <InspectionCustomerUI
              showPrice={!!portalInfo?.showPrice}
              showPartsLabor={!!portalInfo?.showPartsLabor}
              previousTotal={previousTotal}
              repairOrder={repairOrder}
              shop={shop}
              vehicle={vehicle}
              services={services}
              handleDeferOrRecommendService={handleDeferOrRecommendService}
              customerFirstName={customer?.information?.firstname}
            />
          ) : (
            <Stack spacing={1}>
              <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="rectangular" width={210} height={60} />
            </Stack>
          )}
        </Box>
      </Container>
    </Box>
  )
}

export default CustomerPortal
